










































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { mapGetters } from "vuex";
import { Job } from "@/models/job.model";
import store from "../store/store";
import { AssignedJob } from "@/models/assignedJob.model";
import { JobCommand, Action } from "@/models/app.model";
import { setting } from "@/common/settings";
import CleanModal from "@/components/CleanModal.vue";

@Component({
    components: {
        CleanModal,
    },
    filters: {
        shortenStr(value: string) {
            if (value !== null) {
                return value.substring(0, 30) + (value.length > 30 ? ".." : "");
            }
        },
    },
})
export default class JobList extends Vue {
    @Prop() private cardId!: number;
    @Prop() private jobs!: AssignedJob[];
    action = Action;
    setting = setting;

    editJob() {}

    jobDone(job: AssignedJob) {
        // toggle job done
        job.done = !job.done;
        if (job.done) {
            console.log("done");
            this.$store.dispatch("job/setJobDone", {
                id: job.id,
                cardId: this.cardId,
            });
        } else {
            console.log("undone");
            this.$store.dispatch("job/setJobUndo", {
                id: job.id,
                cardId: this.cardId,
            });
        }
    }

    imageIdToLoad: number = 0;
    async showImageModal(id: number) {
        this.imageIdToLoad = id;
        //@ts-ignore
        await this.$refs.imageModal.open("");
    }

    get jobsList() {
        var list = this.$store.getters["job/currentJobsByCardId"](this.cardId);
        let alphaSort = list.sort((a: any, b: any) => {
            try {
                return a.name.localeCompare(b.name);
            } catch {
                return 0;
            }
        });
        let categorySort = alphaSort.sort((a: any, b: any) => {
            return a.categoryId - b.categoryId;
        });

        console.log(categorySort);

        return categorySort;
    }

    set jobsList(jobs: AssignedJob[]) {
        if (jobs.length > 0 && jobs !== null) {
            if (jobs.some((j) => j.cardId != this.cardId)) {
                this.$store
                    .dispatch("job/moveJob", {
                        id: jobs.find((j) => j.cardId != this.cardId)!.id,
                        cardId: this.cardId,
                    })
                    .then((result) => console.log(result));
            }
        }
    }

    getDraggableOptions() {
        return { group: "assignedJob", handle: ".handle" };
    }
}
